export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  ANALYTICS_DASHBOARD: "/analytics-dashboard",
  REPORTS: "/reports",
  CLIENT: "/clients",
  PROJECT: "/projects",
  PROJECT_DETAILS: "/projects/:id",
  TASK_DETAILS: "/projects/:projectId/tasks/:id",
  PROJECT_MANAGE: {
    PROJECT_RESOURCE_MAPPING: "/project-resource-mapping",
    PROJECT_CHANGES: "/project-changes",
    PROJECT_POCS: "/project-pocs",
    PROJECT_MILESTONE:"/project-milestones"
  },
  RESOURCE: "/resources",
  BUSINESS_UNIT: "/business-units",
  COUNTRY: "/countries",
  CLIENT_INDUSTRIES: "/client-industries",
  CLIENT_DESIGNATIONS: "/client-designations",
  CLIENT_POCS: "/client-pocs",
  RESOURCE_SKILLS: "/resource-skills",
  RESOURCE_ROLES: "/resource-roles",
  SUPPORT: {
    USER_GUIDE: "/user-guide",
    IT_SUPPORT: "/it-support",
  },
  ACTIVITY_LOGS: "/activity_logs",
  ROLES: "/roles",
  ROLES_CATEGORIES: "/role-categories",
  ADMINISTRATION: {
    SKILL: "/skill",
    SKILL_CATEGORY: "/skill-category",
    CITY: "/city",
  },
  TAGS: "/tag-activity",
  UNAUTHORIZED: "/unauthorized",
  TIMESHEET: "/timesheet",
  PAGE_NOT_FOUND: "/page-not-found",
};
